import React, { Component } from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import Container from './Container';

@DragDropContext(HTML5Backend)
class ReactDnd extends Component {
    constructor(props){
        super(props);
    }
    render() {
        return (
            <Container {...this.props} />
        );
    }
}
export default ReactDnd;